import { useEffect, useState } from "react";
import axios from "axios";
import { FlaskConical, LogOut, Loader2 } from "lucide-react";
import { API } from "@/constants/roles";

// Permanent banner shown while a View As / Test Mode session is active.
// Restores the owner's token and triggers server-side restore+purge on exit.
export const ViewAsBanner = () => {
  const [meta, setMeta] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    try {
      setMeta(JSON.parse(localStorage.getItem("melto_viewas") || "null"));
    } catch {
      setMeta(null);
    }
  }, []);

  if (!meta) return null;

  const exit = async () => {
    setBusy(true);
    const ownerToken = localStorage.getItem("melto_token_owner");
    try {
      await axios.post(`${API}/admin/viewas/stop`, {}, { headers: { Authorization: `Bearer ${ownerToken}` } });
    } catch { /* restore locally even if the server call fails */ }
    if (ownerToken) localStorage.setItem("melto_token", ownerToken);
    localStorage.removeItem("melto_token_owner");
    localStorage.removeItem("melto_viewas");
    window.location.href = "/dashboard";
  };

  return (
    <div data-testid="viewas-banner" className="sticky top-0 z-[70] flex flex-wrap items-center justify-center gap-x-3 gap-y-1 bg-amber-400 px-4 py-2 text-center text-xs font-bold text-amber-950">
      <span className="flex items-center gap-1.5">
        <FlaskConical className="h-4 w-4" />
        TEST MODE — viewing as {meta.role}. Changes are sandboxed and purged on exit. No emails or notifications leave the system.
      </span>
      <button
        data-testid="viewas-exit-btn"
        onClick={exit}
        disabled={busy}
        className="flex items-center gap-1.5 rounded-full bg-amber-950 px-3.5 py-1.5 text-[11px] font-bold text-amber-100 transition-colors hover:bg-amber-900 disabled:opacity-50"
      >
        {busy ? <Loader2 className="h-3 w-3 animate-spin" /> : <LogOut className="h-3 w-3" />}
        Exit &amp; purge test data
      </button>
    </div>
  );
};
